import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, FileSearch } from "lucide-react";
import IncidentInfo from "./IncidentInfo";
import "./ViewIncident.css";

const ViewIncident = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const incidentData = location.state?.data;

  return (
    <div style={{ margin: "8px", fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&display=swap');`}</style>
      <div className="incv-header-banner">
        <button type="button" className="incv-back-btn" onClick={() => navigate(-1)} aria-label="Back">
          <ArrowLeft size={16} />
        </button>
        <span className="incv-header-icon">
          <FileSearch size={14} color="#fff" />
        </span>
        <div>
          <div className="incv-header-title">View Incident</div>
          <div className="incv-header-subtitle">Full incident lifecycle, details, and activity history</div>
        </div>
      </div>
      <IncidentInfo incidentData={incidentData} />
    </div>
  );
};

export default ViewIncident;
